"use client";

import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useToast } from "../components/ui/use-toast";
import api from "../services/api";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const history = useHistory();
  const { toast } = useToast();

  const handleForgotPassword = async () => {
    if (!email) {
      toast({
        title: "Errore",
        description: "Inserisci l'email",
        variant: "destructive",
      });
      return;
    }
    try {
      await api.post("/forgot-password", { email });
      toast({
        title: "Email inviata",
        description:
          "Se l'email esiste, riceverai le istruzioni per il reset della password. Controlla anche la tua cartella spam.",
      });
    } catch {
      toast({
        title: "Errore",
        description: "Errore nell'invio dell'email",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="glass-card w-full max-w-md rounded-2xl p-8 space-y-6">
        <h1 className="gradient-text text-2xl font-bold text-center">
          Password dimenticata
        </h1>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="esempio@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="backdrop-blur-xl bg-white/5 border border-white/10 shadow-xl"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4">
          <Button
            size="lg"
            className="w-full bg-gradient-to-r from-teal-200 to-teal-500 text-white hover:opacity-90"
            onClick={handleForgotPassword}
          >
            Invia Email Reset
          </Button>

          <Button
            variant="ghost"
            className="w-full text-sm text-teal-400 hover:text-teal-200"
            onClick={() => history.push("/")}
          >
            Torna al Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
